// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3424":"a9bf4ce7","6016":"6c69315f"}[chunkId] + ".chunk.css";
};